var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[(!_vm.currentQuestion)?_c('div',[_c('onboarding-question-index')],1):_vm._e(),(_vm.currentQuestion)?_c('div',[_c('onboarding-question-edit',{attrs:{"embedded":_vm.embedded}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }